module.exports = __webpack_public_path__ + "assets/590e4a8b4b91da6d72251a66a3a7a209.svg";